// Registry of per-action components for the Assignment Pipeline.
//
// Actions are flow-specific: the same action_key can mean something
// different (or not exist at all) depending on the flow's
// state_machine_key (see GET /assignments/:id/flow-statuses — that's where
// state_machine_key comes from). So every action component is registered
// under BOTH identifiers together, never just one — a lookup always needs
// "this action, for this flow", not "this action" in the abstract.
//
// Each action file in this folder should call `registerAction` once, e.g.:
//
//   import { registerAction } from './actionRegistry';
//   import MarkPassedAction from './MarkPassedAction';
//
//   registerAction({
//     stateMachineKey: 'default',
//     actionKey: 'mark_passed',
//     component: MarkPassedAction,
//   });
//
// ...and be imported (for its registration side effect) from ./index.js.

const registry = new Map();

const registryKey = (stateMachineKey, actionKey) =>
  `${stateMachineKey}::${actionKey}`;

export const registerAction = ({ stateMachineKey, actionKey, component }) => {
  if (!stateMachineKey || !actionKey) {
    throw new Error(
      'registerAction requires both stateMachineKey and actionKey'
    );
  }
  registry.set(registryKey(stateMachineKey, actionKey), component);
};

// Returns the registered component for this flow + action, or undefined if
// nothing's registered yet — callers should treat that as "no UI for this
// action" rather than an error, since not every flow implements every
// action.
export const getActionComponent = (stateMachineKey, actionKey) =>
  registry.get(registryKey(stateMachineKey, actionKey));
